<template>
  <div
   :class=" clas || ['d-flex', 'justify-center', 'align-center']"
   :style="customStyle"
  >
    <div class="text-center">
      <v-icon size="45px">not_interested</v-icon>
      <p>No Data Yet</p>
    </div>
  </div>
</template>
<script>
export default {
  props: ['customStyle', 'clas']
}
</script>
